// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ufoK","buttons":"Footer_buttons__28_si"};